/* src/app/modules/portal/components/search-pane/search-pane.component.scss */
:host {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: relative;
  max-width: 680px;
}
#main-search-icon {
  cursor: pointer;
}
sh-card {
  margin-bottom: auto;
  --sh-card-header-wrapper-padding: 0rem 1rem 0rem 1rem;
}
sh-tabs {
  width: 100%;
  border-bottom: 1px solid rgba(var(--ui-1), var(--opacity-6));
  margin-bottom: 0px;
}
[favs]:before {
  content: "\e005";
  margin-right: 0.5rem;
  font-size: 1rem;
  font-family: sh-icons;
  color: rgba(var(--ui-2), var(--opacity-1));
}
.search[searching] sh-card {
  transform: scale(1, 1);
}
.search sh-card {
  transform: scale(0, 0);
  transform-origin: 50% 0%;
}
[screen-desktop-large] :host-context .cancel-search-mobile {
  display: none;
}
[screen-desktop-large] :host-context sh-card {
  width: 60%;
  height: 60%;
  min-width: 1200px;
  max-height: calc(80% - 56px);
  min-height: 300px;
}
[screen-desktop] :host-context .cancel-search-mobile {
  display: none;
}
[screen-desktop] :host-context sh-card {
  width: 60%;
  max-width: 100%;
  height: 60%;
  min-width: 900px;
  max-height: calc(80% - 56px);
  min-height: 300px;
}
input[type=search]::-webkit-search-decoration,
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-results-button,
input[type=search]::-webkit-search-results-decoration {
  display: none;
}
[screen-phone] :host-context input[type=search]::placeholder {
  font-size: 80%;
}
[screen-tablet] :host-context .cancel-search-desktop,
[screen-phone] :host-context .cancel-search-desktop {
  display: none;
}
[screen-tablet] :host-context .search,
[screen-phone] :host-context .search {
  top: 56px;
}
[screen-tablet] :host-context .search [icon=cancel],
[screen-phone] :host-context .search [icon=cancel] {
  display: none;
}
[screen-tablet] :host-context sh-card,
[screen-phone] :host-context sh-card {
  width: 100%;
  min-height: 300px;
  max-height: calc(80% - 56px);
  overflow: hidden;
  margin-bottom: auto;
}
input,
form {
  border: 0px;
  width: 100%;
  padding: 0.5rem;
  outline: none;
  font-size: var(--font-size);
  font-family: "siemens sans", sans-serif;
}
form {
  padding: 0rem;
}
[aria-selected=true],
[keyboard-in-use] input:focus:not([aria-activedescendant]) {
  outline: var(--focus-outline);
  outline-offset: -2px;
}
.desktop-search {
  width: 400px;
  margin: auto;
}
.desktop-search .cancel-search-mobile {
  display: none;
}
[title] {
  font-family:
    bree-headline,
    "Arial Black",
    Calibri,
    sans-serif;
  color: var(--text-primary);
  line-height: var(--sh-access-bar-label-line-height);
  text-overflow: ellipsis;
  align-self: center;
}
[center] {
  display: flex;
  align-items: center;
  flex: 1 0;
  justify-content: center;
  margin-left: 5%;
  margin-right: 5%;
}
[center] input[disabled] {
  opacity: 0.5;
}
[center] sh-progress {
  position: absolute;
  bottom: 0px;
  left: 0.2rem;
  width: calc(100% - 0.4rem);
  height: 2px;
}
[search-bar] {
  position: relative;
  background: var(--base-1);
  max-width: 600px;
  padding-left: 0.75rem;
  border-radius: 10rem;
  overflow: hidden;
}
[search-bar] input {
  background: none;
}
[search-bar] sh-icon[icon=search] {
  height: 35px;
  padding-right: 0.75rem;
  padding-left: 0.5rem;
  background: rgb(var(--ui-2));
  color: var(--base-0);
}
sh-card {
  box-shadow: var(--shadow-raised);
}
.search {
  -webkit-backdrop-filter: saturate(0.4);
  backdrop-filter: saturate(0.4);
  background: rgba(var(--ui-6), 0.5);
  margin-top: var(--padding-top);
  position: fixed;
  z-index: 2;
  width: 100%;
  top: 72px;
  left: 0px;
  height: calc(100% + 80px);
  box-sizing: border-box;
  opacity: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all calc(var(--transition-time) * 2);
}
.search [close-option] {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.search sh-card {
  transition: all calc(var(--transition-time) * 1);
  transform-origin: 50% 0%;
}
app-search-result-list {
  align-self: start;
}
sh-card > *:not(sh-spinner):not(.num-systems) {
  margin-top: initial !important;
}
sh-spinner {
  margin: auto;
}
.search[searching] {
  overflow-y: hidden;
  pointer-events: initial;
  opacity: 1;
}
.modality-settings {
  position: relative;
}
.modality-settings sh-icon {
  right: 1rem;
  top: 1rem;
  position: absolute;
  z-index: 1;
}
.num-systems {
  margin-top: 0.5rem;
}
app-search-result-list {
  width: 100%;
}
/*# sourceMappingURL=search-pane.component.css.map */
